import { Box, Card, CardContent, Typography, Button, Grid, Chip } from '@mui/material';
import { Download, Print, CheckCircle, Cancel } from '@mui/icons-material';
import { reporteIVA } from '../billingData';

const ReportIVA = () => {
  const data = reporteIVA;

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box>
          <Typography variant="h5" component="h1" gutterBottom>
            Declaración de IVA - F07
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Formulario de Declaración de Impuesto al Valor Agregado
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <Chip 
            icon={data.activo ? <CheckCircle /> : <Cancel />} 
            label={data.activo ? 'Activo' : 'Inactivo'} 
            color={data.activo ? 'success' : 'error'}
          />
          <Button variant="outlined" startIcon={<Print />}>
            Imprimir
          </Button>
          <Button variant="contained" startIcon={<Download />} color="primary">
            Exportar PDF
          </Button>
        </Box>
      </Box>

      {/* Periodo */}
      <Card sx={{ mb: 3, backgroundColor: '#e3f2fd' }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="h4" color="primary">
            {data.periodo}
          </Typography>
        </CardContent>
      </Card>

      <Grid container spacing={3}>
        {/* IVA Debitable */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #1976d2', pb: 1 }}>
                IVA DEBITABLE (Salidas)
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Ventas con Crédito Fiscal (CCF)</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ivaDebitable.compras.toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Importaciones</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ivaDebitable.importaciones.toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Notas de Débito Emitidas</Typography>
                  <Typography sx={{ fontWeight: 500 }}>$0.00</Typography>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #1976d2' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL IVA DEBITABLE</Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.ivaDebitable.total.toFixed(2)}</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* IVA Creditable */}
        <Grid item xs={12} md={6}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ borderBottom: '2px solid #388e3c', pb: 1 }}>
                IVA CREDITABLE (Entradas)
              </Typography>
              
              <Box sx={{ mt: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Compras con Crédito Fiscal</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ivaCreditable.ventas.toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Notas de Crédito Recibidas</Typography>
                  <Typography sx={{ fontWeight: 500 }}>${data.ivaCreditable.notasCredito.toFixed(2)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography>Importaciones</Typography>
                  <Typography sx={{ fontWeight: 500 }}>$0.00</Typography>
                </Box>
              </Box>

              <Box sx={{ mt: 3, pt: 2, borderTop: '2px solid #388e3c' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>TOTAL IVA CREDITABLE</Typography>
                  <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>${data.ivaCreditable.total.toFixed(2)}</Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Resultado */}
        <Grid item xs={12}>
          <Card sx={{ backgroundColor: '#fce4ec' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ fontWeight: 700 }}>
                  {data.diferencia >= 0 ? 'IVA A PAGAR' : 'IVA A FAVOR'}
                </Typography>
                <Typography variant="h3" color={data.diferencia >= 0 ? 'error.main' : 'success.main'}>
                  ${Math.abs(data.diferencia).toFixed(2)}
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Info */}
      <Card sx={{ mt: 3, backgroundColor: '#f5f5f5' }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Declaración de IVA - Formulario F07
          </Typography>
          <Typography variant="body2">
            El formulario F07 es utilizado para declarar el Impuesto al Valor Agregado (IVA) de forma mensual. 
            La diferencia entre el IVA debitable (generado por ventas) y el IVA creditable (pagado en compras) 
            determina si hay un saldo a favor o un impuesto a pagar.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ReportIVA;
